import React from "react";

function ScrollTop(props){
    return (
        <>
        <div className="scroll-top material-icons bottom-10 fixed right-8 bg-gray-800/90 text-white p-1 rounded-full rotate-180 scale-150 z-30 opacity-0 transition-all duration-300">
          expand_more
        </div>
        <div className="block hidden bg-[#3b5490] bg-[#f44c4c] bg-[#374151] bg-[black] bg-[#bf7f73] bg-[#646758] bg-[#ebe1d5] bg-[#83b0d9] bg-[gray] rotate-180"></div>
        </>
    )
}
export default ScrollTop;